/**
 * @fileoverview Org portal — Settings › You › Appearance
 * (/org/settings/appearance): light or dark, a preference of this browser,
 * saved locally (lib/theme.js). It was a card on the Admins page until iOS
 * review C10 put what is yours apart from the organization.
 */

import { Card } from "@/components/studio/primitives";
import ThemeToggle from "@/components/ThemeToggle";

export default function OrgAppearancePage() {
  return (
    <div data-testid="org-appearance-page">
      <h1 className="mb-6 font-serif text-2xl font-semibold text-[var(--text-primary)]">Appearance</h1>
      <Card data-testid="appearance-card">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <p className="font-sans text-[13px] text-[var(--text-tertiary)]">
            Light is the default. Dark suits a dim room. Saved on this device.
          </p>
          <ThemeToggle />
        </div>
      </Card>
    </div>
  );
}
